/* unplugin-vue-components disabled */import script from "./KeywordReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./KeywordReport.vue?vue&type=script&lang=ts&setup=true"

import "./KeywordReport.vue?vue&type=style&index=0&id=200a0e34&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-200a0e34"]])

export default __exports__